module.exports = __webpack_public_path__ + "static/media/22-beals-lobster-10_10_2020.d3dc53cb.JPG";